import * as types from './types';

const INITIAL_STATE = {
  report: null,
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.MONTHLY_CLAIM_FORM_LOADING:
      return { ...state, loading: payload };
    case types.MONTHLY_CLAIM_FORM_LOAD_ERROR:
      return {
        ...state,
        loadError: {
          Title: 'Error',
          Message: payload
            ? payload
            : 'An error has occurred. Please try again',
        },
      };
    case types.MONTHLY_CLAIM_FORM_GET_REPORT:
      return {
        ...state,
        report: payload,
      };
    case types.MONTHLY_CLAIM_FORM_CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/monthlyclaimform/state/report/reducer.js